/**
 * Created by dongruihe on 2017/4/6.
 */
import { useragent, validator } from "@xhtech/lux";
import CryptoJS from 'crypto-js'

let self = module.exports;
self.isPhoneNumber = function (value) {
  value = self.trim(value);
  if (!value) return;
  if (/^1(3|4|5|6|7|8|9)\d{9}$/.test(value)) {
  } else {
    return false;
  }
  return true;
};
self.trim = function (value) {
  return value.replace(/\s+/g, "");
};
self.isNumber = function (value, length) {
  value = self.trim(value);
  let reg = new RegExp("^[0-9]*$");
  if (length) {
    if (!value || value.length != length || !reg.test(value)) return false;
  } else {
    if (!value || !reg.test(value)) return false;
  }
  return true
};
self.idCard = function (str) {
  let result = str.match(/\d{15}|\d{18}/);
  if (result == null) {
    return {
      "result": false,
      "message": '格式不正确'
    };
  } else {
    return {
      "result": true,
      "message": ""
    };
  }
};
self.getParam = function (key) {
  let s = location.search;
  let params = s.substr(1, s.length);
  let paramsArray = params.split('&');
  let value = "";
  for (let i = 0; i < paramsArray.length; i++) {
    let paramArray = paramsArray[i].split('=');
    if (paramArray[0] == key) {
      value = paramArray[1];
      // 后面的值覆盖前面的值
    }
  }
  return value;
};

self.getHashParam = function (name) {
  let s = location.hash
  let params = s.substr(1, s.length)
  let paramsArray = params.split('&')
  let value = ''
  for (let i = 0; i < paramsArray.length; i++) {
    let paramArray = paramsArray[i].split('=')
    if (paramArray[0] === name) {
      value = decodeURIComponent(paramArray[1])
      // 后面的值覆盖前面的值
    }
  }
  return value
};

//获取客户端版本号
self.getClientVersion = function () {
  const ua = navigator.userAgent;
  const reg = /\bxhqb\/([0-9.]+)/gi;
  const matchArr = ua.match(reg);
  let version = null;
  if (matchArr && matchArr.length > 0) {
    const temStr = matchArr[0];
    const temArr = temStr.split('/');
    version = temArr[1]
  }
  return version || '';
};

// 修改或增加链接带参数的值
self.setUrlSearch = function (key, value) {
  let s = location.search;
  if (s == "") {
    return "?" + key + "=" + value;
  } else {
    let params = s.substr(1, s.length);
    let paramsArray = params.split('&');
    let paramsValues = {};
    let l = 0;
    for (let i = 0; i < paramsArray.length; i++) {
      let paramArray = paramsArray[i].split('=');
      paramsValues[paramArray[0]] = paramArray[1];
      l++;
    }
    if (paramsValues[key] == null) {
      l++;
    }
    paramsValues[key] = value;
    let newS = "?";
    let c = 0;
    for (let i in paramsValues) {
      newS += i + "=" + paramsValues[i] + "";
      if (c < l - 1) {
        newS += "&";
      }
      c++;
    }
    return newS;
  }
};
self.goTo = function (url) {
  window.location.href = url;
};
self.goBack = function () {
  history.back();
};
self.changeTitle = function (pageTile) {
  document.title = pageTile;
  if (window.xhapp) {
    xhapp.config({
      debugNoBridge: false
    });
    xhapp.changeTitle({ title: pageTile }).then(function (rsp) {
    });
  }
};
// 时间格式化
self.dateFormat = function (timestamp, simplify = false) {
  const zero = function (value) {
    if (value < 10) {
      return '0' + value
    }
    return value
  }

  const myDate = timestamp ? new Date(timestamp) : new Date()
  const year = myDate.getFullYear()
  const month = zero(myDate.getMonth() + 1)
  const day = zero(myDate.getDate())

  const hour = zero(myDate.getHours())
  const minite = zero(myDate.getMinutes())
  const second = zero(myDate.getSeconds())

  return simplify
    ? `${year}年${month}月${day}日`
    : year + '-' + month + '-' + day + ' ' + hour + ':' + minite + ':' + second
};

self.showLoading = function () {
  let loading = document.getElementById('loading');
  if (loading) {
    loading.style.display = 'block';
  }
};
self.closeLoading = function () {
  let loading = document.getElementById('loading');
  let app = document.getElementById('app');
  if (loading) {
    loading.style.display = 'none';
  }
  if (app) {
    app.style.display = 'block';
  }
};

self.isWeiXin = function () {
  var ua = window.navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    return true;
  } else {
    return false;
  }
};
self.getParam = function (name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) {
    return unescape(r[2]);
  }
  return '';
};
self.storage = {
  set: function (name, val, options) {
    var options = options || {};
    if (options.session && window.sessionStorage) {
      window.sessionStorage.setItem(name, JSON.stringify(val));
    } else if (window.localStorage) {
      window.localStorage.setItem(name, JSON.stringify(val));
    } else {
      $.cookie(name, val, options);
    }
  },
  get: function (name, options) {
    var options = options || {};
    if (options.session && window.sessionStorage) {
      return JSON.parse(window.sessionStorage.getItem(name) || null);
    } else if (window.localStorage) {
      return JSON.parse(window.localStorage.getItem(name) || null);
    } else {
      return $.cookie(name);
    }
  },
  clear: function (name, options) {
    var options = options || {};
    if (options.session && window.sessionStorage) {
      window.sessionStorage.removeItem(name);
    } else if (window.localStorage) {
      window.localStorage.removeItem(name);
    } else {
      $.removeCookie(name, options);
    }
  }
};
//验证身份证号码
self.verifyIdcard = function (idcard) {
  if (idcard == "") {
    return true;
  }
  var regex1 = /^[1-9][0-7]\d{4}((([0-9]{3}[1-9]|[0-9]{2}[1-9][0-9]{1}|[0-9]{1}[1-9][0-9]{2}|[1-9][0-9]{3})(((0[13578]|1[02])(0[1-9]|[12][0-9]|3[01]))|((0[469]|11)(0[1-9]|[12][0-9]|30))|(02(0[1-9]|[1][0-9]|2[0-8]))))|((([0-9]{2})(0[48]|[2468][048]|[13579][26])|((0[48]|[2468][048]|[3579][26])00))0229))\d{3}(\d|X|x)?$/;
  /*身份号码位数及格式检验*/
  switch (idcard.length) {
    case 15:
      if ((parseInt(idcard.substr(6, 2)) + 1900) % 4 == 0 || ((parseInt(idcard.substr(6, 2)) + 1900) % 100 == 0 && (parseInt(idcard.substr(6, 2)) + 1900) % 4 == 0)) {
        var regex2 = /^[1-9][0-9]{5}[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))[0-9]{3}$/;//测试出生日期的合法性
      } else {
        var regex2 = /^[1-9][0-9]{5}[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|1[0-9]|2[0-8]))[0-9]{3}$/;//测试出生日期的合法性
      }
      if (regex2.test(idcard))
        return true;
      else
        return false;
      break;
    case 18:
      if (regex1.test(idcard)) {
        var S = (parseInt(idcard.charAt(0)) + parseInt(idcard.charAt(10))) * 7 +
          (parseInt(idcard.charAt(1)) + parseInt(idcard.charAt(11))) * 9 +
          (parseInt(idcard.charAt(2)) + parseInt(idcard.charAt(12))) * 10 +
          (parseInt(idcard.charAt(3)) + parseInt(idcard.charAt(13))) * 5 +
          (parseInt(idcard.charAt(4)) + parseInt(idcard.charAt(14))) * 8 +
          (parseInt(idcard.charAt(5)) + parseInt(idcard.charAt(15))) * 4 +
          (parseInt(idcard.charAt(6)) + parseInt(idcard.charAt(16))) * 2 +
          parseInt(idcard.charAt(7)) * 1 +
          parseInt(idcard.charAt(8)) * 6 +
          parseInt(idcard.charAt(9)) * 3;
        var Y = S % 11;
        var M = "F";
        var JYM = "10X98765432";
        M = JYM.substr(Y, 1);
        /*判断校验位*/
        if (M == idcard.charAt(17).toUpperCase()) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
      break;
    default:
      return false;
  }
};

// 底部添加备案号
self.addICP = function (selector) {
  let text = '';
  let s = document.querySelector(selector);
  if (location.host.indexOf('xhqbapp.com') >= 0) {
    text = '沪ICP备20014574号-1'
  } else if (location.host.indexOf('xiaohuaqb.com') >= 0) {
    text = '沪ICP备20014574号-8'
  } else if (location.host.indexOf('truechine.com') >= 0) {
    text = '沪ICP备2020027929号-2'
  } else if (location.host.indexOf('xhzhw.com') >= 0) {
    text = '沪ICP备20014574号-2'
  } else if (location.host.indexOf('xhqb.com') >= 0) {
    text = '粤ICP备2021018097号'
  }
  if (s) {
    s.appendChild(document.createElement('br'));
    s.appendChild(document.createTextNode(text))
  }
}

/**
 * 分割出一级域名
 * @param {string} val - 二级域名，例：www.xhqb.com
 * @returns {string} - 一级域名，返回 xhqb.com
 */
self.splitHost = function (val) {
  if (!val) return ''
  let arr = val.split('.')
  arr.shift()
  return arr.join('.')
}

// 获取 XHQB
function getBrowserXhqb() {
  const userAgent = window.navigator.userAgent
  let browserName = ''
  if (userAgent.includes('XHQB')) {
    browserName = 'XHQB'
  }
  if (userAgent.includes('XHQBJSB')) {
    browserName = 'XHQBJSB'
  }

  return browserName
}

function isApp() {
  return getBrowserXhqb() === 'XHQB' || getBrowserXhqb() === 'XHQBJSB'
}

function decrypt(word, keyStr, ivStr) {
  const key = CryptoJS.enc.Utf8.parse(keyStr)
  const iv = CryptoJS.enc.Utf8.parse(ivStr)
  let encryptedHexStr = CryptoJS.enc.Hex.parse(word)
  let srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr)
  let decrypt = CryptoJS.AES.decrypt(srcs, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })
  let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8)
  return decryptedStr.toString()
}

self.isAddGw = () => {
  const userAgent = window.navigator.userAgent
  if (userAgent.includes('XHQB') || userAgent.includes('XHQBJSB')) {
    // 在Android端 && app版本大于等于5.22.0
    const version = useragent.getVersion('XHQB')
    if (useragent.isAndroid() &&
      useragent.compareVersion(version, '5.22.0') >= 0) {
      return true
    }
    return false
  } else {
    return true
  }
}

// 区分设备
self.getOsTypeLower = function () {
  if (isApp()) {
    if (useragent.isAndroid()) {
      return 'Android'
    } else if (useragent.isIos()) {
      return 'iOS'
    }
  }
  return 'WAP'
}

/**
 * formdata表单请求跳转招行签约
 * @returns
 */
self.handleFormData = function (formParams, formUrl, formId) {
  const form = document.createElement('form')
  form.setAttribute('id', formId)
  form.setAttribute('method', 'post')
  form.setAttribute('action', formUrl)
  Object.keys(formParams).forEach(name => {
    const value = formParams[name]
    const inputElelment = document.createElement('input')
    inputElelment.setAttribute('type', 'hidden')
    inputElelment.setAttribute('name', name)
    inputElelment.setAttribute('value', value)
    form.appendChild(inputElelment)
  })
  document.documentElement.appendChild(form)
  form.submit()
  document.documentElement.removeChild(form)
}

// 获取res解密后手机号
self.getDecryptPhone = function (marketingId) {
  const { default: Validator } = validator
  const key = 'bbe415s412ABCDEF' //十六位十六进制数作为密钥
  const iv = 'abgd78325djdf234' // 偏移量
  const decryptStr = decrypt(marketingId, key, iv) // 解密
  const { passed } = new Validator().data(decryptStr).phone('')
  if (passed) {
    // 填充手机号
    return decryptStr
  } else {
    return ''
  }
}


// WEBPACK FOOTER //
// ./web/js/common/util.js